import createBlockInputSection from './helpers/createBlockInputSection';
import HideSectionInput from './special-inputs/HideSectionInput';

const ContainerSidebarForm = createBlockInputSection({
  title: 'Container block',
  inputs: ['backgroundColor', 'border', 'borderRadius', 'padding', HideSectionInput],
});

export default ContainerSidebarForm;
